import { P } from "apparatus/library/common";
import { BasicShapes } from "apparatus/library/shapes/common";
import { CompoundPath } from "paper";
export class Star {
    constructor() {
        this.drivers = [
            {
                type: "rectangle",
                minX: 0, maxX: 0,
                minY: -150, maxY: -8,
                toAppearance: (f, p) => f({
                    radius: -p.y,
                }),
                fromAppearance: a => P(0, -a.radius),
                scale: 1.0,
            }
        ];
    }
    render(appearance) {
        const points = appearance.points;
        const radius = appearance.radius;
        const strideAngle = 360 / points;
        const thickness = appearance.thickness;
        const origin = P(0, 0);
        let outerPoint = P(0, -radius);
        let innerPoint = P(0, -radius * thickness).rotate(strideAngle / 2, origin);
        const graphic = new CompoundPath({});
        graphic.moveTo(outerPoint);
        graphic.lineTo(innerPoint);
        for (var i = 0; i < points - 1; i++) {
            outerPoint = outerPoint.rotate(strideAngle, origin);
            innerPoint = innerPoint.rotate(strideAngle, origin);
            graphic.lineTo(outerPoint);
            graphic.lineTo(innerPoint);
        }
        graphic.closePath();
        BasicShapes.applyStyle(graphic, appearance);
        return {
            graphic,
            hitShape: graphic.rectHitShape(),
            watermark: outerPoint,
        };
    }
}
Star.properties = {
    label: "Star",
    defaultAppearance: Object.assign({ radius: 50, thickness: 0.55, points: 5 }, BasicShapes.defaultAppearance),
    appearanceSpecs: [
        ...BasicShapes.specs,
        BasicShapes.header,
        {
            spec: "slider", key: "points", label: "Points",
            min: 4, max: 8, step: 1,
        },
        {
            spec: "slider", key: "radius", label: "Radius",
            min: 8, max: 150
        },
        {
            spec: "slider", key: "thickness", label: "Thickness",
            min: 0.2, max: 0.8, step: 0.05,
        },
    ],
};
